import { motion } from 'framer-motion'
import { Download, FileText, Clock } from 'lucide-react'
import { documents } from '../data'
import { formatDate } from '../utils'
import { Card, CardContent, CardHeader, CardTitle, Button } from '../components/common'

export function DocsPage({ asComponent = false }: { asComponent?: boolean }) {
  return (
    <>
      {!asComponent &&
        <section className="relative h-60 bg-gray-900 text-white">
          <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(/images/docs-banner.jpg)` }}></div>
          <div className="container-custom h-full flex items-center relative z-10">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4">文档中心</h1>
              <p className="text-lg text-white/80">获取系统使用指南和相关文档</p>
            </div>
          </div>
        </section>
      }

      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl md:text-4xl font-bold mb-4"
            >
              文档下载
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg text-gray-600 max-w-2xl mx-auto"
            >
              下载系统使用手册、API文档和相关资料
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-8">
            {documents.map((doc, index) => (
              <motion.div
                key={doc.id}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <Card className="h-full hover:shadow-xl transition-shadow duration-300">
                  <CardHeader>
                    <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-4">
                      <FileText className="w-8 h-8 text-primary-500" />
                    </div>
                    <CardTitle className="text-base font-medium">{doc.title}</CardTitle>
                    {/* <CardDescription>{doc.description}</CardDescription> */}
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                      <span>{doc.fileType}</span>
                      <span>{doc.fileSize}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-sm text-gray-500 mb-6">
                      <Clock className="w-4 h-4" />
                      <span>上传时间：{formatDate(doc.uploadDate)}</span>
                    </div>
                    <Button
                      className="w-full group"
                      asChild
                    >
                      <a href={doc.downloadUrl} download className='flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1'>
                        下载文档
                        <Download className="ml-2 w-4 h-4  " />
                      </a>
                    </Button>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
